export default "__VITE_ASSET__52f81a95__"